/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'vzostupne',
  'fabric.editor.headingLink.copied': 'Skopírované!',
  'fabric.editor.headingLink.copyAnchorLink': 'Skopírovať prepojenie do nadpisu',
  'fabric.editor.headingLink.copyAriaLabel': 'Kopírovať',
  'fabric.editor.headingLink.descSortingLabel': 'zostupne',
  'fabric.editor.headingLink.failedToCopy': 'Nepodarilo sa skopírovať',
  'fabric.editor.headingLink.noneSortingLabel': 'žiadne',
  'fabric.editor.inlineComment.marker.end': 'koniec vnoreného komentára',
  'fabric.editor.inlineComment.marker.start': 'začiatok vnoreného komentára',
};
